import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

function Login() {
  const { login } = useContext(AuthContext);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prevCredentials => ({
      ...prevCredentials,
      [name]: value,
    }));
  };

  const fetchAndStoreConferenceItems = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/all_conference_items`);
      if (!response.ok) {
        throw new Error('Failed to fetch conference items.');
      }
      const data = await response.json();
      const sortedData = data.conference_items.sort((a, b) => a.id - b.id); // Sort the data by ID
      localStorage.setItem('conferenceItems', JSON.stringify(sortedData));
    } catch (error) {
      console.error('Error fetching conference items:', error);
    }
  };
  
  const fetchAndStoreProgramItems = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/all_program_items`);
      if (!response.ok) {
        throw new Error('Failed to fetch program items.');
      }
      const data = await response.json();
      const sortedData = data.program_items.sort((a, b) => a.id - b.id); // Sort the data by ID
      localStorage.setItem('programItems', JSON.stringify(sortedData));
    } catch (error) {
      console.error('Error fetching program items:', error);
    }
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const formBody = new URLSearchParams(credentials).toString();

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody,
      });

      if (!response.ok) {
        throw new Error('Login failed - please review your username and/or password.');
      }

      const data = await response.json();
      login(data.access_token); 
      console.log('Login successful', data);

      // Fetch and store conference items after successful login
      await fetchAndStoreConferenceItems();
      console.log('Fetched all conference items in local storage');

      // Fetch and store conference items after successful login
      await fetchAndStoreProgramItems();
      console.log('Fetched all program items in local storage');

      navigate('/intro');
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message);
    }
  };

  return (
    <div className='login-title fade-in'>
      <h1>Login</h1>
      {error && <p className="login-error-message">{error}</p>}
      <form onSubmit={handleSubmit} className="user-registration-form">
        <div>
          <label htmlFor="username">Email:</label>
          <input
            type="text"
            id="username"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="button-container">
          <button className="login-button" type="submit">Log In</button>
        </div>
      </form>
      <p className="registration-link">
        Don't have an account? <Link to="/register">Register here</Link>
      </p>
      <p className="registration-link">
        <Link to="/forgot-password">Forgot your password?</Link>
      </p>
    </div>
  );
}

export default Login;
